import { Button, Tag, Tooltip } from "antd";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { IconoFlechaIzquierda, IconoFlechaDerecha, IconoHistorial } from "./AuditIconos";

// AUDITORIA-CLINICA-REDISENO (FASE 1 · bloque A) -- barra superior de 56px.
// Identifica SIEMPRE la atención que se está auditando; nunca desaparece al
// corregir (esa era la pérdida de contexto del flujo tabla -> drawer -> modal).
//
// Los chips de estado usan color SEMANTICO, no todos azules: Pendiente gris,
// En proceso ámbar (warning), Auditada verde (success). Se define aquí un mapa
// propio en vez de reutilizar `ESTADO_AUDITORIA_TAG` de la tabla actual porque
// aquel usa "processing" (azul) para EN_PROCESO -- y esa pantalla no se toca.
export const ESTADO_AUDITORIA_CHIP = {
    PENDIENTE: { color: "default", label: "Auditoría pendiente" },
    EN_PROCESO: { color: "warning", label: "Auditoría en proceso" },
    AUDITADA: { color: "success", label: "Auditada" },
};

const CITA_ESTADO_FINALIZADA = 6;

export const fmtFechaHora = (valor) =>
    valor ? format(new Date(valor), "dd/MM/yyyy · HH:mm", { locale: es }) : "Sin fecha registrada";

function AtencionBarraSuperior({
    idcita,
    fecha,
    estadoAuditoria = "PENDIENTE",
    estadoCita,
    chipElegibilidad,
    cola,
    correcciones = 0,
    onVolver,
    onVerHistorial,
}) {
    const chip = ESTADO_AUDITORIA_CHIP[estadoAuditoria] || { color: "default", label: estadoAuditoria };
    const citaFinalizada = Number(estadoCita?.idestado_cita) === CITA_ESTADO_FINALIZADA;

    return (
        <div className="ac-topbar" data-testid="ac-topbar">
            <Button size="small" onClick={onVolver} icon={<IconoFlechaIzquierda />}>
                Lista de auditoría
            </Button>
            <span className="ac-topbar__sep" />
            <span className="ac-topbar__titulo">Atención #{idcita}</span>
            <span className="ac-topbar__fecha">{fmtFechaHora(fecha)}</span>
            <Tag color={chip.color} data-testid="ac-chip-auditoria">
                {chip.label}
            </Tag>
            {estadoCita?.estado && (
                <Tag color={citaFinalizada ? "success" : "default"} data-testid="ac-chip-cita">
                    Cita {String(estadoCita.estado).toLowerCase()}
                </Tag>
            )}

            {chipElegibilidad && (
                <Tooltip title={chipElegibilidad.detalle}>
                    <Tag color={chipElegibilidad.color} data-testid="ac-chip-elegibilidad">
                        {chipElegibilidad.label}
                    </Tag>
                </Tooltip>
            )}

            <div className="ac-topbar__derecha">
                {/* La cola sólo existe si se entró desde la lista (llega por
                    `location.state`): al abrir la URL directamente no hay
                    conjunto filtrado del que decir "12 de 47", y se omite en
                    vez de inventar una posición. */}
                {cola && cola.total > 0 && (
                    <div className="ac-cola" data-testid="ac-cola">
                        <Button
                            size="small"
                            type="text"
                            aria-label="Atención anterior"
                            disabled={!cola.tieneAnterior}
                            onClick={cola.onAnterior}
                            icon={<IconoFlechaIzquierda size={15} />}
                        />
                        <span>
                            {cola.indice + 1} de {cola.total}
                        </span>
                        <Button
                            size="small"
                            type="text"
                            aria-label="Atención siguiente"
                            disabled={!cola.tieneSiguiente}
                            onClick={cola.onSiguiente}
                            icon={<IconoFlechaDerecha size={15} />}
                        />
                    </div>
                )}
                <Tooltip title="Historial de correcciones de esta atención">
                    <Button size="small" onClick={onVerHistorial} icon={<IconoHistorial size={15} />} data-testid="ac-btn-historial">
                        Historial ({correcciones})
                    </Button>
                </Tooltip>
            </div>
        </div>
    );
}

export default AtencionBarraSuperior;
